// Make sure to add new routes here, if there is a new page
export const routePermissionUrl = {
  '/': 'dashboard',
  '/frontend/cms': 'cms',
  '/frontend/seo': 'seo',
  '/provider/providers': 'game_providers',
  '/provider/games': 'games',
  '/marketing-tools/banners': 'advertisement_source',
  '/marketing-tools/marketing-performance': 'marketing_performance',
  '/marketing-tools/categories': 'advertisement_source',
  '/marketing-tools/click-record': 'click_record',
  '/marketing-tools/view-record': 'view_record',
  '/finance/deposits': 'deposit',
  '/finance/withdrawals': 'withdrawal',
  '/finance/manual-adjustment': 'manual_adjustment',
  '/finance/exchange-rate': 'exchange_rate',
  '/finance/bank-management': 'bank_management',
  '/finance/cryptocurrency': 'crypto_currency',
  '/finance/third-party-payment': 'third_party_payment_gateway',
  '/players/players': 'player_list',
  '/players/online-players': 'online_players',
  '/players/missing-players': 'missing_players',
  '/players/messages': 'player_message',
  '/players/vip-system': 'vip_tier_system',
  '/bet/player-bet': 'players_bet',
  '/bet/bet-history': 'bet_history',
  '/operator/operator-list': 'operator_list',
  '/operator/operator-report': 'operator_report',
  '/operator/ggr-report': 'ggr_report',
  '/operator/quota': 'operator_quota',
  '/agents/agents': 'agent_list',
  '/agents/agent-settlement': 'agent_settlement',
  '/player-reward/promotion': 'promotion',
  '/player-reward/promotion-code': 'promo_code',
  '/player-reward/rolling-settings': 'rolling',
  '/player-reward/invite-and-earn': 'player_reward_invite_and_earn',
  '/player-reward/claim': 'player_reward_claims',
  '/player-reward/report': 'player_reward_report',
  '/player-reward/reward-reset-threshold': 'player_reward_reset_threshold',
  '/player-reward/mission-control': 'mission_control',
  '/player-reward/reward-control': 'reward_control',
  '/player-reward/reward-exchange-and-history': 'reward_exchange',
  '/player-reward/coin-history': 'coin_history',
  '/player-reward/coin-history-report': 'coin_report',
  '/reports/report': 'all_summary',
  '/reports/deposit': 'deposit_summary',
  '/reports/withdrawal': 'withdrawal_summary',
  '/reports/company-report': 'company_report',
  '/users/users': 'admin_list',
  '/users/roles': 'admin_role',
  '/users/user-activity': 'admin_activity',
  '/108-support/billing': '108_billing',
  '/setting/operation-setting': 'operation_setting',
  '/setting/turnover-setting': 'turnover_setting',
  '/setting/website-maintenance': 'website_maintenance',
  '/setting/suspend-registration': 'suspend_registration',
  '/setting/admin-risk-control': 'admin_risk_control',
  '/setting/recaptcha-setting': 'recaptcha_setting',
  '/setting/languages': 'language_setting',
  '/setting/language-strings': 'language_strings',
  '/setting/error-code': 'error_code',
  '/setting/promotion-claim-setting': 'promotion_claim_setting',
  '/setting/operator-custom-domain': 'operator_domain',
  '/setting/ip-whitelist': 'ip_whitelist_setting'
}

export function getPermissionCode(route) {
  const matchedKey = Object.keys(routePermissionUrl)
    .filter(key => route.startsWith(key))
    .sort((a, b) => b.length - a.length)[0]

  return matchedKey ? routePermissionUrl[matchedKey] : null
}
